<template>
  <div class="tender-plug__wrapper" :class="{ 'tender-plug__wrapper_light': light }">
    <div
      class="tender-plug spacey-32"
      :class="{ 'tender-plug_small': small, 'tender-plug_large': large }"
    >
      <div v-if="$slots.icon || icon" class="tender-plug__icon-wrapper">
        <slot name="icon">
          <Icon :type="icon" size="128" color="accent" />
        </slot>
      </div>
      <div class="spacey-12 flex-centering flex-column">
        <div v-if="title" class="tender-plug__title">
          {{ title }}
        </div>
        <div v-if="description" class="tender-plug__description">
          {{ description }}
        </div>
      </div>
      <slot name="action">
        <Button v-if="actionText" @click="$emit('action')">
          {{ actionText }}
        </Button>
      </slot>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui-v2/Button';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'TenderPlug',
    components: { Icon, Button },
    props: {
      title: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        default: '',
      },
      actionText: {
        type: String,
        default: '',
      },
      small: {
        type: Boolean,
        default: false,
      },
      large: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
        default: '',
      },
      light: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .tender-plug {
    max-width: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &_large {
      max-width: 577px;
      .tender-plug__icon-wrapper {
        height: 192px;
        width: 192px;
      }
    }

    &__wrapper {
      background-color: $surface2;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      &_light {
        background-color: initial;
      }
    }

    &__icon-wrapper {
      background-color: $semantic-info-surface;
      border-radius: 60px;

      height: 148px;
      width: 148px;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        height: 128px;
        width: 128px;
        path {
          fill: $info500;
        }
      }
    }

    &__title {
      color: $grey900;
      font-weight: bold;
      font-size: 28px;
      line-height: 130%;
    }

    &__description {
      font-size: 16px;
      line-height: 24px;

      text-align: center;
      color: $grey600;
    }
  }
  .tender-plug_small .tender-plug {
    &__icon-wrapper {
      padding: 25px;
      border-radius: 46px;

      svg {
        height: 91px;
        width: 91px;
      }
    }

    &__title {
      font-size: 20px;
      line-height: 142%;
    }

    &__description {
      font-size: 14px;
      line-height: 20px;
    }
  }
</style>
